export default {
  data() {
    return {
      dragState: {
        isDragging: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
        initialX: 0,
        initialY: 0,
        modalElement: null,
      },
    };
  },

  methods: {
    initDraggableModal(modalId) {
      const modal = document.getElementById(modalId);
      if (!modal) return;

      this.dragState.modalElement = modal;

      const dialog = modal.querySelector('.modal-dialog');
      const header = modal.querySelector('.modal-header');
      if (!dialog || !header) return;

      dialog.style.position = 'relative';
      header.style.cursor = 'move';

      const rect = dialog.getBoundingClientRect();
      this.dragState.initialX = rect.left;
      this.dragState.initialY = rect.top;

      header.addEventListener('mousedown', this.onDragStart);
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
    },

    onDragStart(e) {
      const dialog = this.dragState.modalElement.querySelector('.modal-dialog');

      this.dragState.isDragging = true;

      this.dragState.startX = e.clientX - this.dragState.offsetX;
      this.dragState.startY = e.clientY - this.dragState.offsetY;

      dialog.style.transition = 'none';
    },

    onDragMove(e) {
      if (!this.dragState.isDragging) return;

      const dialog = this.dragState.modalElement.querySelector('.modal-dialog');

      this.dragState.offsetX = e.clientX - this.dragState.startX;
      this.dragState.offsetY = e.clientY - this.dragState.startY;

      dialog.style.transform =
        `translate(${this.dragState.offsetX}px, ${this.dragState.offsetY}px)`;
    },

    onDragEnd() {
      this.dragState.isDragging = false;
    },
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
  },
};
